
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 84 84"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M42 84c23.196 0 42-18.804 42-42S65.196 0 42 0 0 18.804 0 42s18.804 42 42 42zm-.502-25.994c2.124 0 4.249.7 5.883 2.02 1.634 1.244 2.696 3.109 2.615 4.974-1.716-.933-3.187-1.477-4.576-1.787-1.39-.389-2.697-.467-4.004-.467-1.307 0-2.615.156-3.922.467-1.307.233-2.778.854-4.494 1.71 0-1.866.98-3.73 2.615-4.974 1.634-1.321 3.758-2.02 5.883-1.943zM57.245 39c4.305.023 7.755.698 7.755 5.022C65 48.428 61.418 52 57 52s-8-3.572-8-7.977C49 39.617 52.582 39 57 39zm-30 0c4.305.023 7.755.698 7.755 5.022C35 48.428 31.418 52 27 52s-8-3.572-8-7.977C19 39.617 22.582 39 27 39z"}})])
          )
        }
      }
    